import React, { useRef } from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import esES from "antd/locale/es_ES";
import "dayjs/locale/es";
import { formatPillDate } from "../../beauty/beautyBooking";

const DAY_KEY = "YYYY-MM-DD";

/**
 * Always-open inline calendar with "Hoy / Mañana" chips (antd DatePicker rendered inside
 * `rmob-calendar-wrap`). Shared by the beauty booking and the birthday flow. Days are
 * "YYYY-MM-DD" keys; `isBookable(dayKey)` adds a rule on top of the min/max window.
 * `desktop` only adds the modifier class for the compact side-by-side card.
 */
const InlineDayPicker = ({ value, onChange, isBookable, minDate, maxDate, desktop = false }) => {
  const calRef = useRef(null);
  const selected = value ? dayjs(value) : null;
  const blocked = (day) => Boolean(isBookable) && !isBookable(day.format(DAY_KEY));

  const today = dayjs().startOf("day");
  const quick = [
    { label: "Hoy", day: today },
    { label: "Mañana", day: today.add(1, "day") },
  ];
  return (
    <div className={desktop ? "beauty-day-picker is-desktop" : undefined}>
      <div className="rmob-date-quick">
        {quick.map(({ label, day }) => {
          const key = day.format(DAY_KEY);
          return (
            <button
              key={label}
              type="button"
              className={`rmob-date-chip${value === key ? " active" : ""}`}
              disabled={blocked(day)}
              onClick={() => onChange(key)}
            >
              {label} {formatPillDate(day).split(" ").slice(1).join(" ")}
            </button>
          );
        })}
      </div>
      <div className="rmob-calendar-wrap" ref={calRef}>
        <DatePicker
          locale={esES.DatePicker}
          value={selected}
          onChange={(d) => { if (d) onChange(d.format(DAY_KEY)); }}
          disabledDate={(current) =>
            current && ((minDate && current.isBefore(minDate, "day")) || (maxDate && current.isAfter(maxDate, "day")) || blocked(current))
          }
          open={true}
          allowClear={false}
          getPopupContainer={() => calRef.current || document.body}
          style={{ display: "none" }}
          popupClassName="rmob-calendar-inline"
        />
      </div>
    </div>
  );
};

export default InlineDayPicker;
